/**
 * 删除对象中所有未定义值的属性。
 *
 * @param {object} obj
 */
export function removeUndefinedProperties(obj) {
    var newObj = {};
    Object.keys(obj)
        .filter(function (key) { return typeof obj[key] !== 'undefined'; })
        .forEach(function (key) {
        newObj[key] = obj[key];
    });
    return newObj;
}
//# sourceMappingURL=objects.js.map